import React from "react";
import classNames from "classnames";


const GameCard = ({item, getColor, referralInitials })=> {

  return (
    <div className="item d-flex">
      <div>
        <span key={item.id} className="initials" style={{backgroundColor: getColor(item) }}> { referralInitials(item) }  </span>
        <span className="ref-name">{ item.firstName } { item.lastName} </span>
      </div>
      <span className={classNames("points", { "empty": !item.points})}> {item.points || 0} points </span>
    </div>
  );
};

export default GameCard;
